export const REQUEST_DEMO_LINK = 'https://calendar.app.google/SV8Qadd7r2zjGiac7'
